import {Check} from '@mui/icons-material'
import {ButtonProps, Button} from '@mui/material'
import React from 'react'

export const ConfirmButton: React.FC<ButtonProps> = (props) => (
  <Button variant="contained" startIcon={<Check />} {...props} />
)
